export * from './select-single.component';
export * from './select-single.module';